export default "__VITE_ASSET__R3H4WHCx__"